import * as amplitude from '@amplitude/analytics-browser';

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

let isInitialized = false;

export const initAmplitude = (): void => {
  if (!AMPLITUDE_API_KEY) {
    return;
  }

  amplitude.init(AMPLITUDE_API_KEY, {
    autocapture: false,
    minIdLength: 1,
  });

  isInitialized = true;
};

export const trackEvent = (
  eventName: string,
  eventProperties?: Record<string, unknown>
): void => {
  if (!isInitialized) {
    return;
  }

  amplitude.track(eventName, {
    ...eventProperties,
    platform_instance: window.location.hostname.includes('demo.verifyiq')
      ? 'demo'
      : 'gcash',
  });
};

export const setUserId = (userId: string | null): void => {
  if (!isInitialized) {
    return;
  }

  amplitude.setUserId(userId ?? undefined);
};

export const setUserProperties = (
  properties: Record<string, unknown>
): void => {
  if (!isInitialized) {
    return;
  }

  const identifyEvent = new amplitude.Identify();
  Object.entries(properties).forEach(([key, value]) => {
    identifyEvent.set(key, value as string | number | boolean | string[]);
  });

  amplitude.identify(identifyEvent);
};

export const resetAmplitude = (): void => {
  if (!isInitialized) {
    return;
  }

  amplitude.reset();
};
